// extracted by mini-css-extract-plugin
export default {"loaderContainer":"_2AX0C","loader":"ezHjj","header":"_1m6KQ"};